import { RESPONSE_STATUS, RESPONSE_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueFormatterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * responseStatusの値を表示用にフォーマット
 * @param ValueFormatterParams （params.valueはnull/'0'/'1'/'2'）
 * @returns 0: 未回答 1: 継続 2: 解除
 */
const responseStatusFormatter = (params: ValueFormatterParams) => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const formattedValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? RESPONSE_STATUS_JA[value] : RESPONSE_STATUS[value]) : value;
  return formattedValue;
};

export default responseStatusFormatter;
